import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ocrLevel } from '../internal/variants.js';
import { Icon } from '../primitives/Icon.js';
export function OCRConfidence({ conf }) {
    const lvl = ocrLevel(conf);
    return (_jsxs("span", { className: 'ocr ' + lvl, title: 'OCR confidence ' + conf + '%', children: [_jsxs("span", { className: "dots", "aria-hidden": "true", children: [_jsx("i", {}), _jsx("i", {}), _jsx("i", {})] }), _jsxs("span", { className: "pct", children: [conf, "%"] })] }));
}
export function ConfirmButton({ done = false, onClick, label = 'confirm' }) {
    return (_jsxs("button", { type: "button", className: 'confirm' + (done ? ' done' : ''), onClick: done ? undefined : onClick, disabled: done, "aria-pressed": done, children: [done && _jsx(Icon, { name: "check", size: 12 }), done ? 'confirmed' : label] }));
}
//# sourceMappingURL=OCRConfidence.js.map